<template>
  <div>
    <ProgressBar active-step="Confirm" />
    <PageHeading :default-heading="pd_content.page_header" />
    <form @submit.prevent>
      <div class="pvd-container container-divider">
        <h2 class="pvd-heading-XL">
          {{ pd_content.account_information_section_header }}
        </h2>
        <ReadbackComponent
          :label="pd_content.account_type_label"
          :values="[pd_content.account_type]"
        />
        <ReadbackComponent
          :label="pd_content.company_name_label"
          :values="[pu_clientName]"
        />
      </div>
      <div class="pvd-container container-divider">
        <h2 class="pvd-heading-XL">
          {{ pd_content.personal_information_section_header }}
          <EditLink page-name="personal-information-is" />
        </h2>
        <ReadbackComponent
          :label="pd_content.participant_label"
          :values="[`${pu_firstName} ${pu_lastName}`, pu_ssn , formattedDate]"
          mask="true"
        />
        <ReadbackComponent
          :label="pd_content.citizenship_label"
          :values="[residenceCountryName]"
        />
        <ReadbackComponent
          :label="pd_content.legal_address_label"
          :values="[pu_leg_line1, pu_leg_line2, cityStateZip]"
          mask="true"
        />
        <ReadbackComponent
          :label="pd_content.mailing_address_label"
          :values="[pu_leg_line1, pu_leg_line2, cityStateZip]"
          mask="true"
        />
      </div>
      <NavigationComponent />
      <FootnoteComponent :content="pd_content.footnote" />
    </form>
  </div>
</template>

<script>
import EditLink from '../components/EditLink.vue';
import FootnoteComponent from '../components/FootnoteComponent.vue';
import NavigationComponent from '../components/NavigationComponent.vue';
import PageHeading from '../components/PageHeading.vue';
import ProgressBar from '../components/ProgressBar.vue';
import ReadbackComponent from '../components/ReadbackComponent.vue';
import dataHelper from '../mixins/dataHelper';
import measurement from '../mixins/measurement';
import utilityFunctions from '../mixins/utility';

export default {
  name: 'ReviewAndConfirmIS',
  components: {
    EditLink,
    FootnoteComponent,
    NavigationComponent,
    PageHeading,
    ProgressBar,
    ReadbackComponent,
  },
  mixins: [dataHelper, measurement, utilityFunctions],
  data() {
    return {
      backButtonAttempt: false,
    };
  },
  computed: {
    residenceCountryName() {
      let countryValue;
      if (this.pu_residenceCountry !== '999') {
        const countryObject = this.pd_countryList
          .validCitizenship.find((element) => element.value === this.pu_residenceCountry);
        countryValue = countryObject.option;
      } else {
        countryValue = 'UNITED STATES';
      }
      return countryValue;
    },
    formattedDate() {
      return this.formatTextualDate(this.pu_dob.toString());
    },
    cityStateZip() {
      let separator = ',';
      if (this.pu_leg_state === '' && this.pu_leg_zip === '') {
        separator = '';
      }
      return `${this.pu_leg_city}${separator} ${this.pu_leg_state} ${this.pu_leg_zip}`;
    },
  },
  mounted() {
    this.track(this.cs_stateName, 'pageview');
    document.title = this.setTitle(this.pd_content.page_header);
    this.configureBackButtonFunctionality(() => this.showBackWarning(
      this.pd_content.back_button_disabled_warning,
    ));
  },
};
</script>

<style lang="scss">
</style>
